import React from 'react';
import AssociatedChecklist from './associatedChecklist';
import PlannedMaintenance from './plannedMaintenance';
import OpenWorkOrder from './openWorkOrder';
import WorkOrderHistory from './workOrderHistory';
import AssetStatusLog from './assetStatusLog';
import ChecklistLog from './checklistLog';
import PartsConsumed from './partsConsumed';
import AssociatedWorkRequestList from './associatedWorkRequestList';
import AssetMovementLogList from './assetMovementLogList';


const Maintenance: React.FC = () => {
    return (
        <div>
            <AssociatedChecklist />
            <AssociatedWorkRequestList />
            <PlannedMaintenance />
            <PartsConsumed />
            <OpenWorkOrder />
            <WorkOrderHistory />
            <ChecklistLog />
            <AssetMovementLogList />
            <AssetStatusLog />
        </div>
    );
};

export default Maintenance;